module.exports = __webpack_public_path__ + "img/teacher.12ca1948.png";